export const trashPageResources = {
  en: {
    breadcrumbs: 'Trash',
    title: 'Trash'
  }
};